import styled from 'styled-components';

export const Container = styled.div`
  a {
    transition: color 0.4s;

    &:hover {
      color: ${p => p.theme.palette.primary.main};
    }
  }
`;

export default Container;
